import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function ProtectedRoute({ children }) {
    const { user, loading } = useAuth();
    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="glass-card px-8 py-6 font-display text-slate-300">
                    Loading…
                </div>
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;
    return children;
}
